import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDivideSign = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 11,
			r: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 20H31",
			stroke: "currentColor",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 29,
			r: 2,
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgDivideSign);
export default ForwardRef;
